// exam time encryption an decryption types
export const ExamTimeTypes = {
    encrypt: 'encrypt',
    decrypt: 'decrypt'
}
// exam time encryption an decryption
export const ExamTime = (type, exma_time) => {
    const optionsArray = ['samsung', 'iran', 'galaxy',
        'sPlus', 'security', 'exam', 'successful', 'failed'];
    const EncryptFormula = () => {
        let words = [];
        for (let i = 0; i < 4; i++) {
            let is_word_repetitious = true;
            while(is_word_repetitious) {
                const word_index = Math.floor(Math.random() * (optionsArray.length - 1));
                if (words.indexOf(optionsArray[word_index]) === -1) {
                    is_word_repetitious = false;
                    words.push(optionsArray[word_index]);
                }
            }
        }
        words.push(exma_time)
        let newString = words.join('');
        let reversedString = newString.split("").reverse().join("");
        let encryptedText = btoa(reversedString).split("").reverse().join("");
        return encryptedText;
    }
    const DecryptFormula = () => {
        let decryptedText = (atob(exma_time.split("").reverse().join(""))).split("").reverse().join("")
        for (let j = 0; j < optionsArray.length; j++) {
            let testArray =  decryptedText.split(optionsArray[j]);
            for (let k = 0; k < testArray.length; k++) {
                if (parseInt(testArray[k])) {
                    return parseInt(testArray[k])
                }
            }
        }
    }
    switch (type) {
        case ExamTimeTypes.encrypt:
            if (exma_time) {
                return EncryptFormula();
            }
            else {
                return null;
            }
        case ExamTimeTypes.decrypt:
            if (exma_time) {
                return DecryptFormula();
            }
            else {
                return null;
            }
        default:
            break;
    }
}